export var ResourceSortField;
(function (ResourceSortField) {
    ResourceSortField["Id"] = "id";
    ResourceSortField["BackupStatus"] = "backupStatus";
    ResourceSortField["ConfigurationStatus"] = "configurationStatus";
    ResourceSortField["AccountId"] = "accountId";
    ResourceSortField["ResourceName"] = "resourceName";
    ResourceSortField["Environment"] = "environment";
    ResourceSortField["ProviderResourceId"] = "providerResourceId";
    ResourceSortField["SizeBytes"] = "sizeBytes";
    ResourceSortField["SnapshotStorageSizeBytes"] = "snapshotStorageSizeBytes";
    ResourceSortField["EonSnapshotCount"] = "eonSnapshotCount";
    ResourceSortField["NonEonSnapshotCount"] = "nonEonSnapshotCount";
    ResourceSortField["LatestSnapshotTime"] = "latestSnapshotTime";
    ResourceSortField["OldestSnapshotTime"] = "oldestSnapshotTime";
    ResourceSortField["DateDiscovered"] = "dateDiscovered";
    ResourceSortField["CreatedTime"] = "createdTime";
    ResourceSortField["ResourceGroupName"] = "resourceGroupName";
    ResourceSortField["ClusterName"] = "clusterName";
    ResourceSortField["GlobalClusterIdentifier"] = "globalClusterIdentifier";
    ResourceSortField["LastDataClassificationTime"] = "lastDataClassificationTime";
})(ResourceSortField || (ResourceSortField = {}));
